import { render } from "./BuildYourStore.vue?vue&type=template&id=5b6c7cdc&scoped=true"
const script = {}

import "./BuildYourStore.vue?vue&type=style&index=0&id=5b6c7cdc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6c7cdc"]])

export default __exports__